import { GET_TEACHING_COURSES } from "../actions";

const initialState = {
  courses: []
};

const teachingCoursesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEACHING_COURSES:
      return {
        ...state,
        courses: action.payload
      };
    default:
      return state;
  }
};

export default teachingCoursesReducer;
